import kovan from '@/connect/coin/kovan'
import mainnet from '@/connect/coin/mainnet'

export const localCoin = {
  42: kovan,
  1: mainnet
}
export default {
  42: kovan,
  1: mainnet
}
